const API_BASE_URL = process.env.WORKFLOW_ADMIN_API_URL || window.WORKFLOW_ADMIN_API_URL || 'http://localhost:8080/api';

async function request(url, options = {}) {
  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
  const csrfToken = document.querySelector('meta[name="_csrf"]')?.content;
  const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content;

  const headers = {
    'Content-Type': 'application/json',
    'X-Audit-User': 'admin',
    ...options.headers
  };

  if (csrfToken && csrfHeader) {
    headers[csrfHeader] = csrfToken;
  }

  try {
    const response = await fetch(fullUrl, {
      ...options,
      headers
    });

    if (response.status === 401) {
      window.location.replace('401.html');
      return { success: false, message: 'Unauthorized.' };
    }

    const data = await response.json().catch(() => ({
      success: false,
      message: 'Invalid response from server.'
    }));

    if (data.sessionexpired === 'Y') {
      window.location.replace('./logout');
      return { success: false, message: 'Session expired.' };
    }

    return data;
  } catch (error) {
    return {
      success: false,
      message: `Network error: ${error.message}`
    };
  }
}

export async function getApplications() {
  return request('/applications');
}

export async function getWorkflows(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  return request(`/WorkflowAdmin?${query.toString()}`);
}

export async function getWorkflow(id) {
  return request(`/WorkflowAdmin/${id}`);
}

export async function openWorkflow(id) {
  return request(`/WorkflowAdmin/${id}/open`);
}

export async function createWorkflow(workflow) {
  return request('/WorkflowAdmin', {
    method: 'POST',
    body: JSON.stringify(workflow)
  });
}

export async function updateWorkflow(id, workflow) {
  return request(`/WorkflowAdmin/${id}`, {
    method: 'PUT',
    body: JSON.stringify(workflow)
  });
}

export async function deleteWorkflow(id) {
  return request(`/WorkflowAdmin/${id}`, {
    method: 'DELETE'
  });
}

export async function activateWorkflow(id) {
  return request(`/WorkflowAdmin/${id}/activate`, {
    method: 'POST'
  });
}

export async function deactivateWorkflow(id) {
  return request(`/WorkflowAdmin/${id}/deactivate`, {
    method: 'POST'
  });
}

export async function publishWorkflow(id, processDeploymentId) {
  return request(`/WorkflowAdmin/${id}/publish`, {
    method: 'POST',
    body: JSON.stringify({ processDeploymentId })
  });
}

export async function startEditWorkflow(id) {
  return request(`/WorkflowAdmin/${id}/start-edit`, {
    method: 'POST'
  });
}

export async function unlockWorkflow(id) {
  return request(`/WorkflowAdmin/${id}/unlock`, {
    method: 'POST'
  });
}
